import React, { useState } from 'react'
import { NavLink } from 'react-router-dom'
import { useTheme } from '../context/ThemeContext'

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const { theme, toggleTheme } = useTheme()
  const navigation = [
    { label: 'Home', path: '/' },
    { label: 'About', path: '/about' },
    { label: 'Services', path: '/services' },
    { label: 'Contact', path: '/contact' }
  ]

  const closeMenu = () => setIsMenuOpen(false)

  return (
    <header className="sticky top-0 z-50 border-b border-blue-300/20 bg-gradient-to-r from-[#071a3d] via-[#0b2d63] to-[#123f7a] shadow-lg shadow-blue-950/20">
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8 lg:px-10" aria-label="Main navigation">
        <NavLink to="/" onClick={closeMenu} className="group flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-cyan-400 text-lg font-black text-[#071a3d] transition-transform group-hover:-rotate-6">P</span>
          <span className="flex flex-col leading-none">
            <span className="text-base font-black tracking-tight text-white sm:text-xl">Papreja</span>
            <span className="mt-1 text-[0.65rem] font-bold uppercase tracking-[0.16em] text-cyan-300 sm:text-xs">Tech Solutions</span>
          </span>
        </NavLink>

        <div className="hidden items-center gap-1 md:flex">
          {navigation.map(({ label, path }) => (
            <NavLink
              key={path}
              to={path}
              className={({ isActive }) => `relative rounded-lg px-4 py-2 text-sm font-semibold transition-colors ${isActive ? 'text-cyan-300' : 'text-blue-100 hover:text-white'}`}
            >
              {({ isActive }) => <><span>{label}</span>{isActive && <span className="absolute inset-x-4 -bottom-1 h-0.5 rounded-full bg-cyan-300" />}</>}
            </NavLink>
          ))}
        </div>

        <div className="hidden items-center gap-3 md:flex">
          {/* <button
            type="button"
            onClick={toggleTheme}
            className="flex h-10 w-10 items-center justify-center rounded-lg text-blue-100 transition hover:bg-white/10 hover:text-white"
            aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
          >
            {theme === 'light' ? '☾' : '☀'}
          </button> */}
          <NavLink to="/contact" className="rounded-lg bg-cyan-400 px-5 py-2.5 text-sm font-bold text-[#071a3d] transition hover:-translate-y-0.5 hover:bg-cyan-300">Let&apos;s talk</NavLink>
        </div>

        <button
          type="button"
          onClick={() => setIsMenuOpen((open) => !open)}
          className="flex h-10 w-10 items-center justify-center rounded-lg text-blue-100 transition hover:bg-white/10 hover:text-white md:hidden"
          aria-expanded={isMenuOpen}
          aria-controls="mobile-navigation"
          aria-label={isMenuOpen ? 'Close navigation menu' : 'Open navigation menu'}
        >
          <span className="text-2xl leading-none">{isMenuOpen ? '×' : '☰'}</span>
        </button>
      </nav>

      {isMenuOpen && (
        <div id="mobile-navigation" className="border-t border-blue-300/20 bg-gradient-to-b from-[#0b2d63] to-[#071a3d] px-5 pb-5 pt-3 md:hidden">
          <div className="flex flex-col gap-1">
            {navigation.map(({ label, path }) => (
              <NavLink
                key={path}
                to={path}
                onClick={closeMenu}
                className={({ isActive }) => `rounded-lg px-4 py-3 text-sm font-semibold ${isActive ? 'bg-white/10 text-cyan-300' : 'text-blue-100 hover:bg-white/5 hover:text-white'}`}
              >
                {label}
              </NavLink>
            ))}
          </div>
          <div className="mt-3 flex items-center gap-3 border-t border-blue-300/20 pt-4">
            <button type="button" onClick={toggleTheme} className="rounded-lg px-4 py-2.5 text-sm font-semibold text-blue-100 hover:bg-white/10 hover:text-white">
              {theme === 'light' ? '☾ Dark mode' : '☀ Light mode'}
            </button>
            <NavLink to="/contact" onClick={closeMenu} className="ml-auto rounded-lg bg-cyan-400 px-4 py-2.5 text-sm font-bold text-[#071a3d]">Let&apos;s talk</NavLink>
          </div>
        </div>
      )}
    </header>
  )
}

export default Navbar
